// Cache for created patterns to prevent memory leaks
const patternCache: Record<string, HTMLCanvasElement> = {};

export const createDotPattern = (color: string) => {
  if (patternCache[color]) {
      return patternCache[color];
  }

  const canvas = document.createElement('canvas');
  canvas.width = 10;
  canvas.height = 10;
  const ctx = canvas.getContext('2d');
  if(ctx) {
      ctx.fillStyle = color;
      ctx.beginPath(); ctx.arc(5,5,2,0,Math.PI*2); ctx.fill();
  }
  
  patternCache[color] = canvas;
  return canvas;
};

export const drawJeans = (ctx: CanvasRenderingContext2D, color: string, shade: string) => {
  // Left Leg
  ctx.fillStyle = color;
  ctx.beginPath(); ctx.moveTo(-10, -90); ctx.lineTo(0, -90); ctx.lineTo(-2, 0); ctx.lineTo(-12, 0); ctx.fill();
  // Right Leg
  ctx.beginPath(); ctx.moveTo(2, -90); ctx.lineTo(12, -90); ctx.lineTo(14, 0); ctx.lineTo(4, 0); ctx.fill();
  // Shading
  ctx.fillStyle = shade;
  ctx.fillRect(-1, -90, 4, 40); // Crotch area
};

export const drawGenericFace = (ctx: CanvasRenderingContext2D, skinColor: string) => {
  ctx.translate(0, -155); // Neck base
  // Neck
  ctx.fillStyle = skinColor;
  ctx.fillRect(-6, -5, 12, 10);
  // Head
  ctx.beginPath();
  ctx.moveTo(-12, -25);
  ctx.quadraticCurveTo(-12, -5, 0, 0); // Chin
  ctx.quadraticCurveTo(12, -5, 12, -25);
  ctx.lineTo(12, -40);
  ctx.lineTo(-12, -40);
  ctx.fill();
  
  // Eyes (K-Pop Style)
  ctx.fillStyle = "#333";
  ctx.beginPath(); ctx.moveTo(-9, -20); ctx.quadraticCurveTo(-6, -22, -3, -19); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(9, -20); ctx.quadraticCurveTo(6, -22, 3, -19); ctx.stroke();
  // Mouth
  ctx.strokeStyle = "#d35400";
  ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(-3, -10); ctx.quadraticCurveTo(0, -8, 3, -10); ctx.stroke();
};

export const drawHighFidelityFace = (ctx: CanvasRenderingContext2D, skinTone: string | CanvasGradient | CanvasPattern, eyeColor: string, hairGrad: CanvasGradient) => {
    ctx.fillStyle = skinTone;
    ctx.beginPath();
    ctx.moveTo(-12, -26);
    // Broadened jawline so it's not a single point
    ctx.quadraticCurveTo(-14, -8, -4, 0); 
    ctx.lineTo(4, 0);
    ctx.quadraticCurveTo(14, -8, 12, -26);
    ctx.lineTo(12, -40); // Forehead
    ctx.lineTo(-12, -40);
    ctx.closePath();
    ctx.fill();

    // Eyes
    ctx.fillStyle = "#fff";
    ctx.beginPath(); ctx.ellipse(-7, -22, 5, 3.5, 0.1, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(7, -22, 5, 3.5, -0.1, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = eyeColor;
    ctx.beginPath(); ctx.arc(-7, -22, 2.5, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(7, -22, 2.5, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = "#000";
    ctx.beginPath(); ctx.arc(-7, -22, 1, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(7, -22, 1, 0, Math.PI * 2); ctx.fill();

    // Nose - Adjusted up from -11 to -15
    ctx.fillStyle = "#d35400";
    ctx.globalAlpha = 0.3;
    ctx.beginPath();
    ctx.arc(0, -15, 1, 0, Math.PI * 2);
    ctx.fill();
    ctx.globalAlpha = 1.0;

    // Mouth (Detailed style from Rumi)
    ctx.fillStyle = "#c0392b";
    ctx.beginPath();
    ctx.ellipse(0, -7, 2.5, 1.5, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "#e74c3c";
    ctx.beginPath();
    ctx.arc(0, -7.5, 1, 0, Math.PI * 2);
    ctx.fill();

    // Hairline
    ctx.fillStyle = hairGrad;
    ctx.beginPath();
    ctx.moveTo(-12, -40); ctx.quadraticCurveTo(0, -50, 12, -40); ctx.lineTo(12,-35); ctx.quadraticCurveTo(0, -45, -12, -35);
    ctx.fill();
};